
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
export default {
data (){
return {
value:'',
mShow:true,
show:false,
showm1:true,
showm2:false,
show_1:false,
alrshow:false,
resends:false,
mShows:true,
picUrl:'',
money1:'',
money2:'',
money3:'',
money4:'',
totalMoneys:'',
lowMoney:'',
txts:'',
openid:'',
phone:'',
comnCode:'',
list:[],
lowPircId:'',
index:'',
godsId:'',
smc:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
srcs:"https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg"
}
},
components:{
XButton,
XHeader,
Alert,
Flexbox,
FlexboxItem,
XImg,
Confirm,
loadPage
},
beforeMount(){
this.firstLoad();
},
mounted(){
if(this.$router.history.current.path == "/marketMyPublish"){
document.title = "我的发布";
}
this.picUrl = global.baseImg;
this.openid = this.$router.history.current.query.openid;
this.phone = this.$router.history.current.query.phone;
this.comnCode = this.$router.history.current.query.comnCode;

},
methods:{
submitForm(){
this.$router.push({path:'/fleaMarketList',query:{}})
},
lowPrice(mid,price){//降价
this.show = true;
this.lowPircId = mid;
this.lowMoney = price;
this.totalMoneys = price;
this.money1 = Number(price)*0.1;
this.money2 = Number(price)*0.3;
this.money3 = Number(price)*0.5;
this.money4 = Number(price)*0.8;

let self = this;
$(".am_expence").delegate("li","click",function(){

$(this).addClass("actived").siblings('li').removeClass("actived");
self.totalMoneys = Number($(".am_expence li.actived .mflex").find("strong").html());
})
},
deleteData(deId){//删除商品
this.show_1 = true;
let urls = global.host + 'secondMarket/deletegoodsinfo?goodsId='+deId;
this.$http.get(urls).then(function(res){
this.show_1 = false;

let code = res.body.code;
if(code == "110"){
this.alrshow = true;
this.txts = res.body.msg;
window.location.reload();
console.log(res.body.msg)
}else if(code == "120"){
this.alrshow = true;
this.txts = res.body.msg;
}
},function(err){
console.log(err)
})
},
replyThing(reId){//重新发布
this.show_1 = true;
let urls = global.host + 'secondMarket/goodsrepublish?goodsId='+reId;
this.$http.get(urls).then(function(res){
this.show_1 = false;

let code = res.body.code;
if(code == "110"){
this.alrshow = true;
this.txts = res.body.msg;
}
},function(err){
console.log(err)
})
},
sendMessages(index){
let size = this.list.length;
for(let i= 0; i < size ; i++){
this.list.pop();
}
if(index == 0){
this.firstLoad();
$(".tabItems .tabliem:first").addClass("actives");
$(".tabItems .tabliem:last").removeClass("actives")
}else if(index == 1){

this.xjFirstLoad();
$(".tabItems .tabliem:first").removeClass("actives");
$(".tabItems .tabliem:last").addClass("actives")
}
},
btnConfirm(){
let urls = global.host + 'secondMarket/goodspricereduction?goodsId='+this.lowPircId+ "&salePrice="+this.totalMoneys ;
this.$http.get(urls).then(function(res){

let code = res.body.code;
if(code == "110"){
this.alrshow = true;
this.txts = res.body.msg;
$("#"+this.lowPircId).find("strong").html(res.body.price)
}
},function(err){
console.log(err)
})
},
feeDown(goodsId){//下架
this.show_1 = true;
this.godsId = goodsId;
let url = global.host + 'secondMarket/goodsDown?goodsId='+goodsId;
this.$http.get(url).then(function(res){
this.show_1 = false;
if(res.body.code == '110'){
this.alrshow = true;
this.txts = res.body.msg;
}else if(res.body.code == '120'){
this.alrshow = true;
this.txts = res.body.msg;
}
},function(err){
console.log(err)
})
},
cancel(){

},
xjFirstLoad(){
this.show_1 = true;
let mNum = 1;
let datas = {
mainPhone:this.$router.history.current.query.mainPhone,
comnCode:this.$router.history.current.query.comnCode,
page:1,
rows:10,
firstflag:1,
isOffline:mNum
}
if(mNum){
this.mShows = false;
}
let url = global.host + 'secondMarket/findgoodslist';
this.$http.post(url,datas).then(function(res){
this.show_1 = false;

let picList = res.body.goods;
for(let m in picList){
if(picList[m].imgs.length>0){
for(let n in picList[m].imgs){
picList[m].imgs[n].minPicUrl = global.baseImg+picList[m].imgs[n].minPicUrl;
}
}

this.list.push(picList[m]);
}

},function(err){
console.log(err)
})
},
firstLoad(){
this.show_1 = true;
let datas = {
mainPhone:this.$router.history.current.query.mainPhone,
page:1,
rows:10
};
this.mShows = true;
let url = global.host + 'secondMarket/findmyselfgoods';
this.$http.post(url,datas).then(function(res){
this.show_1 = false;

let picList = res.body.result;
for(let m in picList){
if(picList[m].imgs.length>0){
for(let n in picList[m].imgs){
picList[m].imgs[n].minPicUrl = global.baseImg+picList[m].imgs[n].minPicUrl;
}
}

this.list.push(picList[m]);
}
},function(err){
console.log(err)
})
}
}

}



// WEBPACK FOOTER //
// ./src/components/fleaMarketComponents/marketMyPublish.vue